import {View} from 'MWC';
import tpl from '../templates/TransferTableAdmin.jsx';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }
}
